var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonpayDarkIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2570,
    height: 1337,
    viewBox: "0 0 2570 1337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_16058)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_703_16058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2570 0H0V1337H2570V0Z",
    fill: "#15072F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_703_16058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718 1145C1394 1145 1942 596.997 1942 -79C1942 -754.997 1394 -1303 718 -1303C42.0035 -1303 -506 -754.997 -506 -79C-506 596.997 42.0035 1145 718 1145Z",
    fill: "#530C8B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M654 1109C1310.11 1109 1842 577.114 1842 -79C1842 -735.114 1310.11 -1267 654 -1267C-2.11426 -1267 -534 -735.114 -534 -79C-534 577.114 -2.11426 1109 654 1109Z",
    fill: "url(#paint0_linear_703_16058)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_703_16058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1684.1 -84.6592C1625.6 587.427 1175.66 963.44 958.001 1067.44L1131.2 292.817L1039.23 -218L1684.1 -84.6592Z",
    fill: "#871FE6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_703_16058",
    x: -534,
    y: -1303,
    width: 3104,
    height: 2644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_703_16058"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_703_16058",
    x: -706,
    y: -1503,
    width: 2848,
    height: 2848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_703_16058"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_703_16058",
    x: 658.001,
    y: -518,
    width: 1326.1,
    height: 1885.44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_703_16058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_703_16058",
    x1: 1338,
    y1: 577,
    x2: 174,
    y2: 321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6519EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#3619B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150F4E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_16058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2570,
    height: 1337,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonpayDarkIllustration);
export default __webpack_public_path__ + "static/media/moonpay-dark-illustration.a4abcc08c8f2212c1ab2d427a16ab9e5.svg";
export { ForwardRef as ReactComponent };